<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Administrator erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.admins.store'))">
                <form-fields 
                    :form="form" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    phone: null,
                    fax: null,
                    email: null,
                    notes: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>